import { __awaiter, __extends, __generator } from "tslib";
import AsyncStorage from '@react-native-async-storage/async-storage';
import Manager from '../Abstracts/Manager';
var StorageManager = /** @class */ (function (_super) {
    __extends(StorageManager, _super);
    function StorageManager() {
        var _this = _super.call(this) || this;
        _this.PREFERENCES = {
            TOKEN: 'TOKEN',
            CONNECTION_METHOD: 'CONNECTION_METHOD'
        };
        return _this;
    }
    StorageManager.prototype.remove = function (key, onSuccess, onError) {
        if (onSuccess === void 0) { onSuccess = function () { }; }
        if (onError === void 0) { onError = function () { }; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, AsyncStorage.removeItem(key, function (error) { return onError(error); }).then(function () { return onSuccess(); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    StorageManager.prototype.store = function (key, value) {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        if (!(value == undefined)) return [3 /*break*/, 2];
                        return [4 /*yield*/, AsyncStorage.setItem(key, "")];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, AsyncStorage.setItem(key, JSON.stringify(value))];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/, true];
                    case 5:
                        error_1 = _a.sent();
                        console.log(error_1);
                        return [2 /*return*/, false];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    StorageManager.prototype.fetch = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var json, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, AsyncStorage.getItem(key)];
                    case 1:
                        json = _a.sent();
                        if (json)
                            return [2 /*return*/, JSON.parse(json)];
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        console.log(error_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/, undefined];
                }
            });
        });
    };
    return StorageManager;
}(Manager));
export default StorageManager;
